import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Panel, Button, Row, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import { useParams, useHistory } from 'react-router-dom'
import ScrutinizeMethodForm from './ScrutinizeMethodForm'
import { getScrutinizeAttachmentMulti, saveScrutinizeMulti } from '../../redux/actions/scrutinize'
import { getSchemaSidebar } from '../../redux/actions/sidebar'
import { isEmpty } from 'lodash'
import ScrutinizeMethodView from './ScrutinizeMethodView'
import { isNewMultiReveiw } from '../../utils/ValidatorUtils'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import pathname from '../../constants/pathname'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import ButtonPanel from '../ButtonPanel'

export default function ScrutinizeMethodWidget({ schema: _schema, ...props }) {
  const { projectIdList, showCommandButton, isEdit, onChangeIsEdit, isSingle, isMeetingResult } =
    props
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [fileError, setFileError] = useState()

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const isEnableCancle = !isNewMultiReveiw(projectId)

  let history = useHistory()

  const handleSave = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      const response = await saveScrutinizeMulti(request)
      // console.log('response', response)
      let responseModel = response.model

      if (isMeetingResult) {
        if (responseModel?.header) {
          responseModel.header = 'ผลการประชุม'
          responseModel.buttonText = 'ผลการประชุม'
        }
      }

      setFormSchema(responseModel)
      setValue(responseModel.attachFiles.name, '')
      onChangeIsEdit(false)
      // window.location.href = `${pathname.proposal.review.scrutinizeMethodMuti}/${response.model.id}`
      if (isSingle) {
        await dispatch(getSchemaSidebar(projectId))
      } else if (!isSingle && isMeetingResult) {
        sessionStorage.setItem('projectId', response.model.id)
        history.push(`${pathname.proposal.review.meetingSummaryMulti}`)
        // history.push(`${pathname.proposal.review.meetingSummaryMulti}/${response.model.id}`)
      } else {
        sessionStorage.setItem('projectId', response.model.id)
        history.push(`${pathname.proposal.review.scrutinizeMethodMuti}`)
        // history.push(`${pathname.proposal.review.scrutinizeMethodMuti}/${response.model.id}`)
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('onSubmit data', data)

    const formData = new FormData()

    if (isSingle) {
      formData.append('projectVersionIds', projectId)
    } else {
      if (projectIdList && projectIdList.length > 0) {
        projectIdList?.forEach((element) => {
          formData.append('projectVersionIds', element)
        })
      }
      if (!isNewMultiReveiw(projectId)) {
        formData.append('groupId', projectId)
      }
    }

    !isEmpty(data.attachFiles) &&
      data.attachFiles?.forEach((element) => {
        formData.append('files', element.blobFile)
      })

    let scrutinizeMethod
    if (isMeetingResult) {
      scrutinizeMethod = formSchema?.scrutinizeMethod?.value
    } else {
      scrutinizeMethod = data.scrutinizeMethod
    }

    formData.append('reviewType', scrutinizeMethod)

    if (scrutinizeMethod == 2) {
      formData.append('meetingName', data.meettingName)
      formData.append('meetingDate', data.meettingDate)
    }

    formData.append('isSingle', isSingle ? true : false)

    if (data?.deleteFileList?.length > 0) {
      console.log(data.deleteFileList.join(','))
      formData.append('deleteFileIds', data.deleteFileList.join(','))
    }
    // console.log('formData', formData, isSingle ? true : false)
    handleSave(formData)
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      const file = await getScrutinizeAttachmentMulti(
        isSingle ? [projectId] : projectIdList.join(','),
        fileObj.id
      )
      previewFile(file, fileObj.fileName)
    } catch (err) {
      setFileError('แสดงเอกสารไม่สำเร็จ')
    }
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      const file = await getScrutinizeAttachmentMulti(
        isSingle ? [projectId] : projectIdList.join(','),
        fileObj.id
      )
      downloadFile(file, fileObj.fileName)
    } catch (err) {
      setFileError('ดาวน์โหลดเอกสารไม่สำเร็จ')
    }
    doneLoading()
  }

  return (
    <Panel shaded header={formSchema.header} eventKey={2} collapsible defaultExpanded>
      {showCommandButton && isEdit ? (
        <ScrutinizeMethodForm
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          onDownload={onDownload}
          onPreview={onPreview}
          fileError={fileError}
          isMeetingResult={isMeetingResult}
        />
      ) : (
        <ScrutinizeMethodView
          schema={formSchema}
          onDownload={onDownload}
          onPreview={onPreview}
          fileError={fileError}
          isMeetingResult={isMeetingResult}
        />
      )}
      {showCommandButton && (
        <>
          <hr />
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || 'วิธีการกลั่นกรองทางวิชาการ'}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(false)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
          />

          {/* {isError && (
            <Row style={{ marginBottom: 10 }}>
              <Message
                showIcon
                type="error"
                description={`บันทึก${formSchema.buttonText || ''}ไม่สำเร็จ`}
              />
            </Row>
          )}

          {isEdit ? (
            <>
              <Button appearance="ghost" onClick={handleSubmit(onSubmit)} disabled={isLoading}>
              {formSchema.buttonText || 'บันทึกวิธีการกลั่นกรองทางวิชาการ'}
              </Button>

              {isEnableCancle && (
                <Button
                  style={{ marginLeft: 20 }}
                  appearance="ghost"
                  onClick={() => {
                    onChangeIsEdit(false)
                  }}
                  disabled={isLoading}
                >
                  {'ยกเลิกแก้ไขวิธีการกลั่นกรองทางวิชาการ'}
                </Button>
              )}
            </>
          ) : (
            <Button
              appearance="ghost"
              onClick={() => {
                onChangeIsEdit(true)
              }}
              disabled={isLoading}
            >
              {'แก้ไขวิธีการกลั่นกรองทางวิชาการ'}
            </Button>
          )} */}
        </>
      )}
    </Panel>
  )
}
